export default __webpack_public_path__ + "static/media/asset1.35110f93.png";